import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context";
import Rotate from "./Rotate";
import Button from "./Button";
import leftArrow from "../img/left.png";
import rightArrow from "../img/right.png";
import white_tick from "../img/white_tick.png";
import crossBtn from "../img/cross.png";
import {
  totalImagesUploadStatus,
  userLogs,
  patLogs,
  feedBackStatus,
  translateText,
  getImageFeedbackMsg,
  setTotalImageFeedbackMssg,
  isAllImgUploaded,
  imageUpload,
  getKotakRecaptureCase,
  imageFeedback,
  getKotakRecapMenuSection,
  sendRakutenCallback,
  getImgFeedbackFlag,
  getTotalImageFeedbackMssgResume,
  setImageFeedbackResumeStatus,
  setFeedBackStatus,
  setFeedbackCountResume,
  addImageToList,
  getTotalImageFeedbackMssg,
  getCountDownTimer,
  getImageQueueLength,
  setDocumentTagIndex,
  getRecaptureColorCoding
} from "../context/utils";
// import { processImage } from "../context/example";
import car_inspection from "../img/car_inspection.png";

// import ReactGA from "react-ga4";

let allMandatoryCompleted = true;
let allCompleted = true;
let alignment = false;
let mandatoryMissing = [];
let totalMissing = [];
let logsbugs = true;
let damageModuleExists = false;
let interval;
let totalModuleComplete = "";
let interval2, interval5;
let documentTagIndex = [];

const Menu = () => {
  const {
    setCondition,
    setMandatory,
    currentBlock,
    damageModuleCompleted,
    stepCovered,
    setStepCovered,
    showAlert,
    config,
    setCurrentBlock,
    screen,
    setScreen,
    condition,
    isLandscape,
    setLandscape,
    mandatory,
    completed,
    setCompleted,
    mandatoryCompleted,
    setMandatoryCompleted,
    count1,
    clientId,
    setCount1,
    token,
    setUploaded,
    scrollX,
    setscrollX,
    scrolEnd,
    setscrolEnd,
    setStopPing,
    setCurrentPage,
    inspectionId,
    showFeedBackWarning,
    setShowFeedBackWarning,
    imageFeedbackPopupRef,
    setImageFeedbackPopupRef,
    setFeedbackReceived,
    setFeedBackBtndisabled,
    totalImageForAnalysis,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const modalRef = useRef();
  let scrl = useRef();
  const recptureModalRef = useRef();
  const kotakRecapturePopup = useRef();
  const documentSelectRef = useRef();
  const menufeedBackPopUp = useRef();
  const imageFeebackPopup = useRef();
  const confirmEnd2 = useRef();
  const [documentSelected, setDocumentSelected] = useState("");
  const [reduce, setReduce] = useState(false);
  const [menuBlocks, setMenuBlocks] = useState(config["blocks"]);
  const [tempFlag, setTempFlag] = useState(true);
  const [intervalRef, setIntervalRef] = useState(true);
  const [countDown, setCountDown] = useState(getCountDownTimer());
  const [damageUiUpdate, setDamageUiUpdate] = useState(false);

  window.onresize = () => {
    //patLogs(land() ? "Landscape Mode" : "Portrait Mode", inspectionId);
    //userLogs({ position: 11, screen_orientation: "yes", inspectionId });
    setLandscape(land());
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const slide = (shift) => {
    scrl.current.scrollLeft += shift;
    setscrollX(scrollX + shift);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const checkFeebdackStatus = async () => {
    setTimeout(async () => {
      if (getImgFeedbackFlag()) {
        let result = await isAllImgUploaded(inspectionId);
        let imageFeedbackMsg = getTotalImageFeedbackMssgResume();
        let tempmsgFeedback = {};
        if (Object.keys(imageFeedbackMsg).length > 0) {
          for (let e in imageFeedbackMsg) {
            if (imageFeedbackMsg[e].length > 0) {
              tempmsgFeedback[e] = imageFeedbackMsg[e];
            }
          }
          if (
            Object.keys(config).includes("resumeFlow") &&
            config["resumeFlow"]
          ) {
            if (Object.keys(tempmsgFeedback).length > 0)
              setFeedbackReceived(Object.keys(tempmsgFeedback));
            if (Object.keys(tempmsgFeedback).length > 0 && result)
              setImageFeedbackResumeStatus("Feedback", true);
            else if (result)
              setImageFeedbackResumeStatus("Feedback_Resume", true);
          } else {
            if (Object.keys(tempmsgFeedback).length > 0)
              setFeedbackReceived(Object.keys(tempmsgFeedback));
          }
          setFeedBackBtndisabled(true);
          setFeedBackStatus("Feedback");
          setFeedbackCountResume(0);
        }
        totalImageForAnalysis.map((e) => {
          if (!Object.keys(imageFeedbackMsg).includes(e.currentTag)) {
            addImageToList(e);
          } else {
            if (imageFeedbackMsg[e.currentTag].length === 0) {
              addImageToList(e);
            } else {
              setFeedBackStatus("Feedback");
            }
          }
        });
        if (
          Object.keys(getTotalImageFeedbackMssg()).length === 0 ||
          Object.keys(tempmsgFeedback).length === 0
        ) {
          setFeedBackStatus("noFeedback");
          return;
        }
        userLogs({
          position: 17,
          feedback_countDown: feedBackStatus() + " " + 2,
          inspectionId,
        });
      }
    }, 8000);
  };

  const success = () => {
    patLogs(`Submit button clicked`, inspectionId);
    if (!allMandatoryCompleted || !allCompleted) {
      patLogs(
        `Submit button clicked and warning given to user that some module is not completed`,
        inspectionId
      );
      // patLogs(
      //   `Submit button clicked and warning given to user that some module is not completed -> ${totalMissing.join(
      //     ", "
      //   )}`,
      //   inspectionId
      // );
      if (imageFeedbackPopupRef) {
        imageFeebackPopup.current.style.display = "none";
        setImageFeedbackPopupRef(false);
        clearInterval(interval2);
      }
      modalRef.current.style.display = "flex";
      return;
    }
    if (feedBackStatus() === "checking") {
      menufeedBackPopUp.current.style.display = "flex";
      if (["client_hiib", "client_hiib_uat"].includes(clientId))
        checkFeebdackStatus();
    } else if (feedBackStatus() === "Feedback") {
      menufeedBackPopUp.current.style.display = "none";
      if (process.env.REACT_APP_IMAGE_SLIDER) {
        sortBlock("Feedback");
      }
      setShowFeedBackWarning(true);
      clearInterval(interval);
    } else if (feedBackStatus() === "noFeedback") {
      if (
        [
          "client_1298",
          "client_1298_prod",
          "client_1298_dev",
          "client_1511",
        ].includes(clientId)
      )
        sendRakutenCallback(inspectionId, token);
      clearInterval(interval);
      if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
        if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
        else setScreen("success");
      }
      else setScreen("success");
    } else {
      if (
        Object.keys(config).includes("recaptureAfterSubmit") &&
        config["recaptureAfterSubmit"] &&
        getKotakRecaptureCase()
      ) {
        setInterval(() => imageUpload(inspectionId), 1000);
      }
      if (
        [
          "client_1298",
          "client_1298_prod",
          "client_1298_dev",
          "client_1511",
        ].includes(clientId)
      )
        sendRakutenCallback(inspectionId, token);
      clearInterval(interval);
      if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
        if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
        else setScreen("success");
      }
      else setScreen("success");
    }
    checkData();
  };

  const checkData = () => {
    interval = setInterval(() => {
      if (feedBackStatus() === "checking") {
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "flex";
      } else if (feedBackStatus() === "Feedback") {
        clearInterval(interval);
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "none";
        setShowFeedBackWarning(true);
      } else if (feedBackStatus() === "noFeedback") {
        clearInterval(interval);
        if (menufeedBackPopUp && menufeedBackPopUp.current)
          menufeedBackPopUp.current.style.display = "none";
        if (
          [
            "client_1298",
            "client_1298_prod",
            "client_1298_dev",
            "client_1511",
          ].includes(clientId)
        )
          sendRakutenCallback(inspectionId, token);
        if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
          if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
          else setScreen("success");
        }
        else setScreen("success");
      } else {
        clearInterval(interval);
        if (
          [
            "client_1298",
            "client_1298_prod",
            "client_1298_dev",
            "client_1511",
          ].includes(clientId)
        )
          sendRakutenCallback(inspectionId, token);
        if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
          if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
          else setScreen("success");
        }
        else setScreen("success");
      }
    }, 1000);
  };

  const modalSuccess = () => {
    patLogs(
      `Warning given to user, some module is not completed, still clicked to submit button`,
      inspectionId
    );
    // patLogs(
    //   `Warning given to user, this module ${totalMissing.join(
    //     ", "
    //   )}  is not completed, still clicked to submit button`,
    //   inspectionId
    // );
    if (feedBackStatus() === "checking") {
      menufeedBackPopUp.current.style.display = "flex";
      if (["client_hiib", "client_hiib_uat"].includes(clientId))
        checkFeebdackStatus();
    } else if (feedBackStatus() === "Feedback") {
      menufeedBackPopUp.current.style.display = "none";
      setShowFeedBackWarning(true);
      if (process.env.REACT_APP_IMAGE_SLIDER) {
        sortBlock("Feedback");
      }
      clearInterval(interval);
    } else if (feedBackStatus() === "noFeedback") {
      if (
        [
          "client_1298",
          "client_1298_prod",
          "client_1298_dev",
          "client_1511",
        ].includes(clientId)
      )
        sendRakutenCallback(inspectionId, token);
      clearInterval(interval);
      if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
        if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
        else setScreen("success");
      }
      else setScreen("success");
    } else {
      if (
        [
          "client_1298",
          "client_1298_prod",
          "client_1298_dev",
          "client_1511",
        ].includes(clientId)
      )
        sendRakutenCallback(inspectionId, token);
      clearInterval(interval);
      if (Object.keys(config).includes("customer-declaration") || Object.keys(config).includes("addcarlQuestion")) {
        if (config["customer-declaration"] || config["addcarlQuestion"]) setScreen("KarlQuestion")
        else setScreen("success");
      }
      else setScreen("success");
    }
    checkData();
  };

  const saveFeedbacKMsg = async () => {
    let resultMsg = await getImageFeedbackMsg();
    if (resultMsg && resultMsg !== "noFeedback") {
      setTotalImageFeedbackMssg(resultMsg);
    }
    await isAllImgUploaded(inspectionId);
  };

  const sortBlock = (feedback) => {
    let tempCurrentBlock = menuBlocks;
    if (feedback === "Feedback") {
      tempCurrentBlock.sort((a, b) => {
        if (a["tag"] === "360 Image") return -1;
        if (b["tag"] === "360 Image") return 1;
        return 0;
      });
    } else {
      const totalMissingSet = new Set(totalMissing);
      const mandatoryMissingSet = new Set(mandatoryMissing);

      tempCurrentBlock.sort((a, b) => {
        const aMandatoryIncomplete = mandatoryMissingSet.has(a["id"]);
        const bMandatoryIncomplete = mandatoryMissingSet.has(b["id"]);

        const aIncomplete = totalMissingSet.has(a["id"]);
        const bIncomplete = totalMissingSet.has(b["id"]);

        // Sort by mandatory and incomplete status
        if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
        if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

        if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

        if (aIncomplete && !bIncomplete) return -1;
        if (!aIncomplete && bIncomplete) return 1;

        return 0;
      });
    }
    setMenuBlocks(tempCurrentBlock);
  };

  const removeModal = () => {
    // patLogs(
    //   `user clicked cross button to close warning and move to menu page`,
    //   inspectionId
    // );
    modalRef.current.style.display = "none";
  };

  useEffect(() => {
    config["blocks"].map((e) => {
      if (Object.values(e).includes("damage")) {
        damageModuleExists = true;
      }
    });
    if (logsbugs) {
      // ReactGA.send({
      //   hitType: "pageview",
      //   page: "Menu Page",
      //   title: "Menu Page",
      // });
      //patLogs(land() ? "Landscape Mode" : "Portrait Mode", inspectionId);
      // userLogs({ position: 8, last_page: "menu page", inspectionId });
      logsbugs = false;
    }
    setStopPing(true);
    allCompleted = true;
    allMandatoryCompleted = true;
    mandatoryMissing = [];
    totalMissing = [];
    setLandscape(land());
    if (config["blocks"].length <= 3) {
      alignment = true;
    }
    Object.keys(mandatory).map((item) => {
      if (mandatory[item] === "pending") {
        mandatoryMissing.push(item);
        allMandatoryCompleted = false;
      }
    });
    Object.keys(condition).map((item) => {
      if (condition[item] === "pending") {
        totalMissing.push(item);
        allCompleted = false;
      }
    });
    setCount1(count1 + 1);
    if (allCompleted) setCompleted(true);
    if (allMandatoryCompleted) setMandatoryCompleted(true);

    config["blocks"].map((e) => {
      if (e["id"].length > 14) {
        setReduce(true);
      }
    });
    totalModuleComplete = "";
    Object.keys(condition).map((e) => {
      if (condition[e] === "completed") {
        totalModuleComplete = e + "," + totalModuleComplete;
      }
    });
    userLogs({
      position: 13,
      completed_module: totalModuleComplete,
      inspectionId,
    });
    if (Object.keys(config).includes("TimeOut")) {
      setTimeout(() => {
        if (!["success"].includes(screen)) {
          setScreen("timeOut");
        }
      }, config["TimeOut"]["timeInMinutes"] * 1000 * 60);
    }
    if (process.env.REACT_APP_IMAGE_SLIDER && totalModuleComplete.length > 0) {
      sortBlock();
    }

    if (imageFeedbackPopupRef) {
      if (imageFeebackPopup && imageFeebackPopup.current)
        imageFeebackPopup.current.style.display = "flex";
      else {
        interval2 = setInterval(() => {
          if (imageFeebackPopup && imageFeebackPopup.current) {
            imageFeebackPopup.current.style.display = "flex";
            clearInterval(interval2);
          }
        }, 500);
      }
    }

    if (isLandscape) {
      if (Object.keys(config).includes("directModule")) {
        clearInterval(interval);
        patLogs(`Switch to video module directly`, inspectionId);
        setCurrentBlock(config["blocks"][0]);
        setScreen("block");
      }
    }
  }, [isLandscape, damageUiUpdate]);

  useEffect(() => {
    if (["client_hiib", "client_hiib_uat", ""].includes(clientId)) {
      interval5 = setInterval(() => {
        if (getCountDownTimer() > 0) {
          setCountDown(getCountDownTimer());
        } else {
          setCountDown(0);
          clearInterval(interval5);
        }
      }, 500);
    }
    return () => {
      if (interval5) clearInterval(interval5);
    };
  }, []);

  useEffect(() => { }, [showFeedBackWarning, tempFlag]);

  useEffect(() => {
    userLogs({ position: 8, last_page: "menu page", inspectionId });
    //processImage();
    if (
      Object.keys(config).includes("resumeFlow") &&
      config["resumeFlow"] &&
      Object.keys(config).includes("imageFeedback")
    ) {
      saveFeedbacKMsg();
    }
  }, []);

  const selectModule = (item) => {
    setCurrentBlock(item);
    if (
      Object.keys(config["damage-page"]).includes("checkDamage") &&
      config["damage-page"]["checkDamage"] &&
      item.name === "damage"
    ) {
      confirmEnd2.current.style.display = "flex";
    } else {
      //patLogs(`click to ${item.tag}`, inspectionId);
      if (Array.isArray(item["tag"])) {
        setDocumentSelected(item["tag"][0]);
        setDocumentTagIndex(item["tag"][0]);
        documentTagIndex = item["tag"];
        documentSelectRef.current.style.display = "flex";
      }
      else setScreen("block");
    }
  };


  return !isLandscape ? (
    <Rotate />
  ) : (
    <div
      className="process"
      style={{
        position: "relative",
        height: ["porto_seguros"].includes(clientId) ? "90dvh" : "100dvh",
      }}
    >
      {Object.keys(config).includes("directModule") ? (
        ""
      ) : (
        <h2>{config["menu-page"]["title"]}</h2>
      )}
      <div ref={documentSelectRef} className="imageFeedBackCompletePopup">
        <div className="imageFeedBackInnerDiv" style={{ zIndex: 5 }}>
          <p>{getTranslateText("Please select the document type to proceed")}</p>
          <div id="documentSelection" style={{ width: "100%" }}>
            <div className="div-input" style={{ width: "100%" }}>
              <select
                className="form-select"
                style={{ width: "35dvw" }}
                value={documentSelected}
                onChange={(e) => {
                  setDocumentTagIndex(e.target.value);
                  setDocumentSelected(e.target.value);
                }
                }
              >
                <option
                  className="form-select-option"
                  value=""
                  style={{ display: "none" }}
                ></option>
                {documentTagIndex.map((g) => (
                  <option className="form-select-option" value={g}>
                    {Object.keys(config["single-image"]).includes("document-selection") ? config["single-image"]["document-selection"][g] : getTranslateText(g)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-btn-container">
            <Button
              text={config["intro-page"]["btn-text"]}
              onclick={() => setScreen("block")}
            />
          </div>
        </div>
      </div>
      <div ref={imageFeebackPopup} className="imageFeedBackCompletePopup">
        <div className="imageFeedBackInnerDiv" style={{ zIndex: 5 }}>
          <p>
            {Object.keys(config).includes("imageFeedback") &&
              Object.keys(config["imageFeedback"]).includes(
                "ImageAnalysisCompleteText"
              )
              ? config["imageFeedback"]["ImageAnalysisCompleteText"]
              : getTranslateText(
                "Analysis is completed please click on submit and upload button"
              )}
          </p>
          <div className="modal-btn-container">
            <Button
              text={config["menu-page"]["modal-btn-next"]}
              disabled={!mandatoryCompleted}
              onclick={success}
            />
          </div>
        </div>
      </div>
      {/* kotak recapture case popup */}
      <div ref={kotakRecapturePopup} className="kotakRecaptureNotAllowPopup">
        <div style={{ zIndex: 5 }}>
          <p style={{ margin: "2px" }}>
            {Object.keys(config["menu-page"]).includes(
              "recaptureNotAllowPopupText"
            )
              ? config["menu-page"]["recaptureNotAllowPopupText"]
              : getTranslateText(
                "You can't recapture this section. Please continue to recapture other sections."
              )}
          </p>
          <button
            className="feedbackbtn"
            style={{ backgroundColor: config["colors"]["btn"] }}
            onClick={() => {
              kotakRecapturePopup.current.style.display = "none";
            }}
          >
            {Object.keys(config["menu-page"]).includes(
              "recaptureNotAllowPopupBtnTxt"
            )
              ? config["menu-page"]["recaptureNotAllowPopupBtnTxt"]
              : getTranslateText("Ok got it")}
          </button>
        </div>
      </div>
      <div ref={menufeedBackPopUp} className="imageFeedBackPopup">
        <div style={{ zIndex: 5 }}>
          {["client_hiib", "client_hiib_uat", ""].includes(clientId) ? (
            <p>
              {`Please wait for ${countDown} seconds while we analyse the images`}
            </p>
          ) : (
            <p>
              {Object.keys(config).includes("imageFeedback") &&
                Object.keys(config["imageFeedback"]).includes(
                  "ImageAnalysisMssg2"
                )
                ? config["imageFeedback"]["ImageAnalysisMssg2"]
                : getTranslateText(
                  "Please wait for some time while we analyse the images"
                )}
            </p>
          )}
          <img
            style={{ width: "100px", height: "100px" }}
            src={car_inspection}
          />
        </div>
      </div>

      <div className="process-main">
        <div
          className="left-btn"
          disabled={scrollX === 0}
          onClick={() => slide(-200)}
          style={alignment ? { display: "none" } : {}}
        >
          <img src={leftArrow} style={scrollX <= 0 ? { opacity: "0.3" } : {}} />
        </div>
        <div
          className="process-steps"
          ref={scrl}
          onScroll={scrollCheck}
          style={
            alignment
              ? { display: "flex", justifyContent: "center", width: "100vw" }
              : {
                display: "flex",
                justifyContent: "flex-start",
                width: "80vw",
                overflowX: "scroll",
                scrollBehavior: "smooth",
              }
          }
        >
          {menuBlocks.map((item, index) => {
            if (
              item["tag"] === "360 Image" &&
              feedBackStatus() === "Feedback" &&
              showFeedBackWarning === true
            ) {
              return (
                <div key={index}>
                  <div
                    className="menu-options"
                    style={reduce ? { fontSize: "13px" } : null}
                  >
                    {item["mandatory"] ? (
                      <h4 style={{ color: "red" }} key={index}>
                        {item["id"]}&#42;
                      </h4>
                    ) : (
                      <h4 style={{ color: "red" }} key={index}>
                        {item["id"]}
                      </h4>
                    )}
                    <div
                      className="process-vin"
                      style={{
                        border: "2px solid red",
                      }}
                      onClick={() => {
                        clearInterval(interval);
                        setCurrentBlock(item);
                        //patLogs(`click to ${item.tag}`, inspectionId);
                        setScreen("block");
                      }}
                    >
                      <img src={item["link"]} alt="123"></img>
                    </div>
                  </div>
                </div>
              );
            }
            if (condition[item["id"]] === "completed") {
              return (
                <div key={index}>
                  <div
                    className="menu-options"
                    style={reduce ? { fontSize: "13px" } : null}
                  >
                    {item["mandatory"] ? (
                      <h4
                        style={{
                          color:
                            getKotakRecaptureCase() && !getRecaptureColorCoding() && 
                              getKotakRecapMenuSection().includes(item["tag"])
                              ? "rgb(0, 180, 160)"
                              : config["colors"]["complete-block"],
                        }}
                        key={index}
                      >
                        {item["id"]}&#42;
                      </h4>
                    ) : (
                      <h4
                        style={{
                          color:
                            getKotakRecaptureCase() && !getRecaptureColorCoding() && 
                              getKotakRecapMenuSection().includes(item["tag"])
                              ? "rgb(0, 180, 160)"
                              : config["colors"]["complete-block"],
                        }}
                        key={index}
                      >
                        {item["id"]}
                      </h4>
                    )}
                    <div
                      className="process-vin"
                      style={{
                        border:
                          getKotakRecaptureCase() && !getRecaptureColorCoding() && 
                            getKotakRecapMenuSection().includes(item["tag"])
                            ? `2px solid rgb(0, 180, 160)`
                            : `2px solid ${config["colors"]["complete-block"]}`,
                        opacity:
                          imageFeebackPopup.current &&
                            imageFeebackPopup.current.style.display === "flex"
                            ? ".5"
                            : "",
                      }}
                      onClick={() => {
                        if (
                          Object.keys(config).includes(
                            "recaptureAfterSubmit"
                          ) &&
                          config["recaptureAfterSubmit"] &&
                          getKotakRecaptureCase() &&
                          !getKotakRecapMenuSection().includes(item["tag"])
                        ) {
                          if (
                            item["link"] ===
                            "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_360+view.svg"
                          ) {
                            kotakRecapturePopup.current.style.display = "flex";
                          } else selectModule(item);
                        }
                      }}
                    >
                      <div
                        className="greenCircleTick"
                        style={
                          imageFeebackPopup.current &&
                            imageFeebackPopup.current.style.display === "flex"
                            ? { opacity: ".5" }
                            : {
                              backgroundColor:
                                getKotakRecaptureCase() && !getRecaptureColorCoding() &&
                                  getKotakRecapMenuSection().includes(
                                    item["tag"]
                                  )
                                  ? "rgb(0, 180, 160)"
                                  : "",
                            }
                        }
                      >
                        <img src={white_tick} alt="1232"></img>
                      </div>
                      <img src={item["link"]} alt="123"></img>
                    </div>
                  </div>
                </div>
              );
            }
            return Object.keys(config).includes("directModule") ? (
              ""
            ) : (
              <div key={index}>
                <div
                  className="menu-options"
                  style={reduce ? { fontSize: "14px" } : null}
                >
                  {item["mandatory"] ? (
                    <h4 key={index}>{item["id"]}&#42;</h4>
                  ) : (
                    <h4 key={index}>{item["id"]}</h4>
                  )}
                  <div
                    className="process-vin"
                    style={{
                      border: `1px solid ${config["colors"]["incomplete-block"]}`,
                    }}
                    onClick={() => {
                      selectModule(item);
                      // throw new Error('This is your first error!');
                    }}
                  >
                    <img src={item["link"]} alt="123"></img>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="right-btn"
          disabled={scrolEnd}
          onClick={() => slide(+200)}
          style={alignment ? { display: "none" } : {}}
        >
          <img src={rightArrow} style={scrolEnd ? { opacity: "0.3" } : {}} />
        </div>
      </div>

      <div ref={confirmEnd2} className="confirmEnd2">
        <div className="confirmEndBox" style={{ zIndex: 5 }}>
          <p>
            {Object.keys(config["damage-page"]).includes("damageCheckMsg")
              ? config["damage-page"]["damageCheckMsg"]
              : getTranslateText("Is there any damage to the car ?")}
          </p>
          <div className="confirmEndBoxBtn">
            <Button
              className="start"
              style={{ marginTop: "0px", padding: "0px" }}
              onclick={() => {
                if (currentBlock["mandatory"]) {
                  let temp1 = mandatory;
                  temp1[currentBlock["id"]] = "completed";
                  setMandatory(temp1);
                }
                let temp = condition;
                temp[currentBlock["id"]] = "completed";
                setCondition(temp);
                patLogs(
                  "Damages Module Submited (user clicked to end button)",
                  inspectionId
                );
                confirmEnd2.current.style.display = "none";
                setTempFlag(false);
                setDamageUiUpdate(true);
              }}
              text={
                Object.keys(config["damage-page"]).includes("damageCheckNoBtn")
                  ? config["damage-page"]["damageCheckNoBtn"]
                  : getTranslateText("No")
              }
            />
            <Button
              className="start"
              style={{ marginTop: "0px", padding: "0px" }}
              onclick={() => {
                confirmEnd2.current.style.display = "none";
                setCurrentBlock(currentBlock);
                setScreen("block");
              }}
              text={
                Object.keys(config["damage-page"]).includes("damageCheckYesBtn")
                  ? config["damage-page"]["damageCheckYesBtn"]
                  : getTranslateText("Yes")
              }
            />
          </div>
        </div>
      </div>

      <div className="InternetWarning">
        <p>
          {feedBackStatus() === "Feedback" && showFeedBackWarning === true
            ? Object.keys(config).includes("imageFeedback") &&
              Object.keys(config["imageFeedback"]).includes("recaptureMssg")
              ? config["imageFeedback"]["recaptureMssg"]
              : "Few images captured incorrectly. Please click red sections to recapture"
            : showAlert && showAlert}
        </p>
      </div>
      <div className="modal-btn-container">
        <Button
          text={config["menu-page"]["btn-text"]}
          disabled={!mandatoryCompleted}
          onclick={() => {
            if (
              (confirmEnd2.current.style.display === "none" ||
                confirmEnd2.current.style.display === "") &&
              (modalRef.current.style.display === "none" ||
                modalRef.current.style.display === "")
            ) {
              if (
                Object.keys(config).includes("recaptureAfterSubmit") &&
                config["recaptureAfterSubmit"] &&
                getKotakRecaptureCase() &&
                getImageQueueLength() === 0
              ) {
                recptureModalRef.current.style.display = "flex";
              } else {
                success();
              }
            }
          }}
        />
      </div>
      <div ref={recptureModalRef} className="menu-modal-container">
        <div id="menu-modal">
          <h4 style={{ margin: "0px", padding: "0px" }}>
            {getTranslateText(
              "You haven’t captured any photos. Please capture at least one photo to proceed"
            )}
          </h4>
          <div className="modal-btn-container">
            <Button
              text={getTranslateText("Ok got it")}
              onclick={() => {
                recptureModalRef.current.style.display = "none";
              }}
            />
          </div>
        </div>
      </div>

      <div ref={modalRef} className="menu-modal-container">
        {!mandatoryCompleted ? (
          <div className="menu-modal">
            <div className="menu-back-btn">
              <i className="fas fa-times fa-lg" onClick={removeModal}></i>
            </div>
            <h4>{config["menu-page"]["mandatory-modal-text"]}</h4>
            <h4>{mandatoryMissing.join(", ")}</h4>
          </div>
        ) : mandatoryCompleted && !completed ? (
          <div className="menu-modal">
            {!damageModuleCompleted &&
              Object.keys(config["menu-page"]).includes(
                "damageConfirmationPopup"
              ) &&
              damageModuleExists ? (
              <>
                <h4>{config["menu-page"]["damageConfirmationPopup"]}</h4>
                <br></br>
                <br></br>
                <div className="damageConfirmationPopup">
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupYesBtn"]}
                    onclick={() => {
                      modalSuccess();
                      modalRef.current.style.display = "none";
                    }}
                  />
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupNoBtn"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      removeModal();
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="menu-back-btn">
                  <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                </div>
                <h4>{config["menu-page"]["optional-modal-text"]}</h4>
                {feedBackStatus() === "Feedback" && showFeedBackWarning ? (
                  <h4>
                    {totalMissing.join(", ") +
                      ", " +
                      config["blocks"].filter(
                        (e) => e["tag"] === "360 Image"
                      )[0]["id"]}
                  </h4>
                ) : (
                  <h4>{totalMissing.join(", ")}</h4>
                )}
                <div className="modal-btn-container">
                  <Button
                    text={config["menu-page"]["modal-btn-next"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      modalSuccess();
                    }}
                  />
                </div>
              </>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Menu;
